import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const ItemDefaultProps = {
  ...ClassNameDefaultProps,
  color: null,
  formats: {},
  images: [],
  linkPdf: null,
  name: null,
};

export const ItemPropTypes = {
  ...ClassNamePropTypes,
  color: PropTypes.string,
  formats: PropTypes.shape({
    phone: PropTypes.string,
    tablet: PropTypes.string,
    desktop: PropTypes.string,
    large: PropTypes.string,
    full: PropTypes.string,
  }),
  id: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      destination: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  linkPdf: PropTypes.string,
  name: PropTypes.string,
};
